/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint weekend — sprint scoring uses lower point values`)
};

const es_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin de semana sprint — la puntuación del sprint usa valores más bajos`)
};

const de_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprint-Wochenende — Sprint-Wertung verwendet niedrigere Punktwerte`)
};

const nl_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprintweekend — sprintscoring gebruikt lagere puntwaarden`)
};

const fr_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week-end sprint — la notation sprint utilise des valeurs de points plus faibles`)
};

const it_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekend sprint — il punteggio sprint usa valori di punti più bassi`)
};

const pt_br2_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim de semana sprint — a pontuação sprint usa valores de pontos menores`)
};

const pt_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim de semana sprint — a pontuação sprint usa valores de pontos menores`)
};

const ja_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スプリントウィークエンド — スプリントスコアリングは低いポイント値を使用`)
};

const zh_f1_points_sprint_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲刺周末 — 冲刺赛计分使用较低积分值`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_points_sprint_note = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_points_sprint_note(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_points_sprint_note", locale)
	if (locale === "en") return en_f1_points_sprint_note(inputs)
	if (locale === "es") return es_f1_points_sprint_note(inputs)
	if (locale === "de") return de_f1_points_sprint_note(inputs)
	if (locale === "nl") return nl_f1_points_sprint_note(inputs)
	if (locale === "fr") return fr_f1_points_sprint_note(inputs)
	if (locale === "it") return it_f1_points_sprint_note(inputs)
	if (locale === "pt-BR") return pt_br2_f1_points_sprint_note(inputs)
	if (locale === "pt") return pt_f1_points_sprint_note(inputs)
	if (locale === "ja") return ja_f1_points_sprint_note(inputs)
	return zh_f1_points_sprint_note(inputs)
};